export default "__VITE_ASSET__9e4c9b68__"